export function timestampConverter(unix_timestamp) {
  /* Create a new JavaScript Date object based on Unix timestamp.
    Multiplied it by 1000 to convert it into milliseconds */
  const date = new Date(unix_timestamp * 1000);
  const dateString = `${date.toLocaleDateString(
    "en-US"
  )} , ${date.toLocaleTimeString("en-US")}`;
  // Generate date string
  return dateString;
}

export function tempToColor(temp) {
  let color = "#b2f2bb";
  if (temp < 10) color = "#a5d8ff";
  if (temp > 30) color = "#ffc9c9";
  return color;
}
export function generateOptions(option) {
  let options = {
    key: "temp",
    name: "temperature",
    unit: " celsius",
    color: "#f27785",
  };
  if (option === "clouds") {
    options["key"] = "clouds";
    options["name"] = "cloudiness";
    options["unit"] = " %";
    options["color"] = "#07edcb";
  }
  if (option === "humidity") {
    options["key"] = "humidity";
    options["name"] = "humidity";
    options["unit"] = " %";
    options["color"] = "#0791ed";
  }
  if (option === "pressure") {
    options["key"] = "pressure";
    options["name"] = "pressure";
    options["unit"] = " hPa";
    options["color"] = "#ad4b05";
  }
  if (option === "visibility") {
    options["key"] = "visibility";
    options["name"] = "visibility";
    options["unit"] = " meters";
    options["color"] = "#84e615";
  }
  return options;
}
